module.exports = __webpack_public_path__ + "static/media/responsive-modules.22b761e9.png";